const initialState = () => {
  return {
    listBlocks: []
  }
};

const state = initialState();

const mutations = {
  SET_LIST_BLOCKS(state, payload) {
    state.listBlocks = payload
  }
};

const actions = {
  getListblocks({state, commit}, payload) {
    commit('SET_LIST_BLOCKS', payload)
  }
};

const getters = {
};

const CatalogCategoryList = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};

export default CatalogCategoryList;
